import React from "react";
import "./NewNote.css";
import NewNote from "./NewNote";

export default function NewDrawNote() {
  return (<NewNote img={true}/>);
}